import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

// Official Microsoft Azure "Subnet" service icon, transcribed from the
// Azure Architecture Icons set (November 2025)
// (https://learn.microsoft.com/en-us/azure/architecture/icons/). The
// source artwork is 18×18 — wrapped in `<g transform="translate(2 2)
// scale(2)">` to fit the codebase's 40×40 icon grid (see `azureNic`).
// Visually: four corner brackets (light-blue tips, dark-blue stems)
// enclose a central green dot — the standard Azure "subnet boundary"
// glyph. The vertical green linear-gradient on the dot is approximated
// with the dominant colour `#86d633` to avoid `<defs>` (no other icon
// uses gradients, so this keeps id-collision risk zero).
function createAzureSubnetIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <g transform="translate(2 2) scale(2)">
      <path d="M9.031,7.7A1.305,1.305,0,1,0,10.338,9,1.305,1.305,0,0,0,9.031,7.7Z" fill="#86d633"/>
      <path d="M2.961,7.374h.888a.284.284,0,0,1,.284.284v6.551a.568.568,0,0,1-.568.568H2.677a0,0,0,0,1,0,0V7.659A.284.284,0,0,1,2.961,7.374Z" transform="translate(13.653 16.485) rotate(134.919)" fill="#50e6ff"/>
      <path d="M2.913,3.244H3.8a.284.284,0,0,1,.284.284v7.015a0,0,0,0,1,0,0H3.2a.568.568,0,0,1-.568-.568V3.528a.284.284,0,0,1,.284-.284Z" transform="translate(5.847 -0.358) rotate(44.919)" fill="#1490df"/>
      <path d="M13.867,7.374h.888a.568.568,0,0,1,.568.568v6.551a.284.284,0,0,1-.284.284h-.888a.284.284,0,0,1-.284-.284V7.374a0,0,0,0,1,0,0Z" transform="translate(12.132 -7.079) rotate(45.081)" fill="#50e6ff"/>
      <path d="M14.483,3.244h.888a0,0,0,0,1,0,0v7.015a.284.284,0,0,1-.284.284H14.2a.284.284,0,0,1-.284-.284V3.812a.568.568,0,0,1,.568-.568Z" transform="translate(29.879 1.435) rotate(135.081)" fill="#1490df"/>
    </g>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const azureSubnetIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAzureSubnetIcon,
);
